import { render, staticRenderFns } from "./dietRecord.vue?vue&type=template&id=11359e82&scoped=true&"
import script from "./dietRecord.vue?vue&type=script&lang=js&"
export * from "./dietRecord.vue?vue&type=script&lang=js&"
import style0 from "./dietRecord.vue?vue&type=style&index=0&id=11359e82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11359e82",
  null
  
)

export default component.exports